// extracted by mini-css-extract-plugin
export default {"container":"Ol7SG","logo":"kARJh","nowrap":"KL-w3","modalTrigger":"_0LF9Y","extraSpace":"ahOIm"};